var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogomarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 58,
    viewBox: "0 0 40 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.153748 24.2883C4.47395 17.6623 11.7499 13.312 19.9975 13.312C28.2478 13.312 35.5258 17.6652 39.8455 24.2948C39.9475 23.439 40 22.5671 40 21.6823C40 10.132 31.0457 0.768555 20 0.768555C8.95431 0.768555 0 10.132 0 21.6823C0 22.5648 0.0522694 23.4345 0.153748 24.2883ZM0.156378 33.7053C4.47558 40.334 11.7555 44.6869 20.0082 44.6869C28.2522 44.6869 35.5252 40.3433 39.8462 33.7267C39.9477 34.5801 40 35.4495 40 36.3316C40 47.8744 31.0457 57.2316 20 57.2316C8.9543 57.2316 0 47.8744 0 36.3316C0 35.4421 0.0531727 34.5656 0.156378 33.7053ZM19.8832 41.1608C11.54 41.1608 4.37035 36.1369 1.23513 28.9496C4.37673 21.7773 11.5386 16.7664 19.871 16.7664C28.2142 16.7664 35.3839 21.7903 38.5191 28.9776C35.3775 36.1499 28.2156 41.1608 19.8832 41.1608Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogomarkWhite);
export default __webpack_public_path__ + "static/media/logomark-white.f0f9de616d4fe2a5d1f4b88410576a5c.svg";
export { ForwardRef as ReactComponent };